/**
 * Genesys Products enums specific to Docebo's mapping of the product.
 * This must match for searching
 * The dispay names are used for UI for search accordion
 * The default value with display name is the Docebo product name.
 */
export enum Product {
  AGENT_PLATFORM_DISPLAY_NAME = 'Agent Platform (AP) Training for Genesys Cloud',
  AGENT_PLATFORM_DISPLAY_NAME_2 = 'Agent Platform (AP)',
  AGENT_PLATFORM_DISPLAY_NAME_ENGLISH = 'Agent Platform (AP) Training for Genesys Cloud - English',
  AGENT_PLATFORM_DISPLAY_NAME_SPANISH = 'Agent Platform (AP) Training for Genesys Cloud - Spanish',
  AGENT_PLATFORM_DISPLAY_NAME_PORTUGUESE = 'Agent Platform (AP) Training for Genesys Cloud - Portuguese',
  GENESYS_CLOUD = 'Genesys Cloud', // Docebo Value
  GENESYS_CLOUD_DISPLAY_NAME = 'Genesys Cloud', // Same thing as Genesys Cloud
  GENESYS_CLOUD_PREMIER_PARTNER = 'Genesys Cloud Premier Partner',
  GENESYS_CLOUD_TRIAL = 'Genesys Cloud TRIAL',
  AI_ESSENTIALS_DISPLAY_NAME = 'AI Essentials',
  GENESYS_ENGAGE_CLOUD = 'Genesys Engage Cloud', // Does not have a subscription, uses the same Genesys Engage subscription. This is the value for Genesys Multicloud below.
  GENESYS_ENGAGE = 'Genesys Engage', // Requires a subscription
  GENESYS_ENGAGE_DISPLAY_NAME = 'Genesys Engage on-premises', // Requires a subscription
  POINTILLIST = 'Pointillist',
  PURE_CONNECT = 'PureConnect',
  PURE_CONNECT_DISPLAY_NAME = 'PureConnect',
}
